module.exports = __webpack_public_path__ + "img/40.bb5e24fa.jpg";